import React, { useState } from "react";
import Dialog from '@mui/material/Dialog';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SurgicalHistoryDialog = (props) => {
    const [state, setState] = useState({
        Diagnosis: "",
        startDate: null,
        endDate: null,
        ongoing: "No",
        submitError: false
    });

    const submitData = () => {
        if(state.ongoing == "Yes"){
            state.endDate = null
        }
        if (state.Diagnosis === '' || state.Diagnosis.trim() === '' || !state.startDate || state.ongoing == "No" ? !state.endDate : state.endDate) {
            setState({ ...state, submitError: true });
        } else {
            const data = state;
            delete data.submitError;
            props.handleClose(state);
            setState({ ...state, submitError: false });
        }
    }

    const popperProps = {
        positionFixed: true
    }

    return <Dialog disableEscapeKeyDown={true} open={props.open} onClose={(e, reason) => {
        if (reason !== 'backdropClick') {
            props.handleClose(e);
        }
    }}>
        <div className="dialog">
            <div className="dialog__header">MEDICAL / SURGICAL HISTORY</div>
            <div className="dialog__heading">
                Event/Diagnosis
            </div>
            <input className={`w-100 input ${state.submitError && (state.Diagnosis === '' || state.Diagnosis.trim() === '') && 'error-border'}`} value={state.Diagnosis} onChange={e => setState({ ...state, Diagnosis: e.target.value })} />
            <div className="questions">
                Ongoing:
                <div className="options">
                    <RadioGroup row aria-label="gender" name="ongoing" value={state.ongoing} onChange={e => setState({ ...state, ongoing: e.target.value })}>
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                </div>
            </div>
            <div className="dialog__dates">
                <div className="d-grid">
                    <div className="dialog__heading">
                        Start Date:
                    </div>
                    <DatePicker className={(state.submitError && !state.startDate) && 'error-border'} maxDate={state.endDate} popperProps={popperProps} dateFormat="dd/MM/yyyy" selected={state.startDate} onChange={date => setState({ ...state, startDate: date })} />
                </div>
                {state.ongoing == "No" && (<div className="d-grid">
                    <div className="dialog__heading">
                        End Date:
                    </div>
                    <DatePicker className={(state.submitError && !state.endDate) && 'error-border'} minDate={state.startDate} popperProps={popperProps} dateFormat="dd/MM/yyyy" selected={state.endDate} onChange={date => setState({ ...state, endDate: date })} />
                </div>)}
            </div>
            
            <div className="d-grid buttons justify-content-around">
                <button className="btn secondary-button" onClick={() => props.handleClose('cancel')}>Cancel</button>
                <button className="btn primary-button" onClick={submitData}>Submit</button>
            </div>
        </div>
    </Dialog>;
}

export default SurgicalHistoryDialog;